const getAdminPermission = () => {
  try {
    const storedData = localStorage.getItem("adminLogin");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      return parsedData?.activeUser?.permission || null;
    }
    return null;
  } catch (error) {
    console.error("Error retrieving admin permissions:", error);
    return null;
  }
};

export const getUserType=()=>{
    try {
      const storedData = localStorage.getItem("adminLogin");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        return parsedData?.activeUser?.userType || null;
      }
      return null;
    } catch (error) {
      console.error("Error retrieving admin userType:", error);
      return null;
    }
}

export default getAdminPermission;
